import { render, staticRenderFns } from "./platform_allinpay_flow_list.vue?vue&type=template&id=0fc0f005&scoped=true"
import script from "./platform_allinpay_flow_list.vue?vue&type=script&lang=js"
export * from "./platform_allinpay_flow_list.vue?vue&type=script&lang=js"
import style0 from "./platform_allinpay_flow_list.vue?vue&type=style&index=0&id=0fc0f005&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0f005",
  null
  
)

export default component.exports